import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import useLtxToken from '@/hooks/use-ltx-token';
import useAuthenticate from '@/hooks/use-authenticate';
import useLogout from '@/hooks/use-logout';
import useToken from '@/hooks/use-token';
import useParams from '@/hooks/use-params';

type TokenParse = {
  email: string;
};

const useTokenSessionInvalidated = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {initialized} = useToken();
  const {ltxToken, ltxTokenInitialized} = useLtxToken();
  const {onAuthenticate} = useAuthenticate();
  const {logout} = useLogout();
  const params = useParams();
  const location = useLocation();

  const onError = (error: string) => {
    logout();
  };

  useEffect(() => {
    (async () => {
      if (initialized && ltxTokenInitialized && ltxToken) {
        const currentPath = location.pathname + location.search;
        const {email} = jwt_decode<TokenParse>(ltxToken);
        const data = {
          ...params,
          email,
          password: ltxToken,
        };
        setIsLoading(true);
        const isAuthenticateSuccess = await onAuthenticate(
          data,
          onError,
          currentPath !== '/' ? currentPath : undefined
        );
        setIsLoading(false);
        if (!isAuthenticateSuccess) {
          logout();
        }
      }
    })();
  }, [initialized, ltxTokenInitialized, ltxToken]);

  return {
    isLoading,
  };
};

export default useTokenSessionInvalidated;
